import { render, staticRenderFns } from "./SidebarMenuBadge.vue?vue&type=template&id=56c1bc8c&"
import script from "./SidebarMenuBadge.vue?vue&type=script&lang=js&"
export * from "./SidebarMenuBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56c1bc8c')) {
      api.createRecord('56c1bc8c', component.options)
    } else {
      api.reload('56c1bc8c', component.options)
    }
    module.hot.accept("./SidebarMenuBadge.vue?vue&type=template&id=56c1bc8c&", function () {
      api.rerender('56c1bc8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SidebarMenu/SidebarMenuBadge.vue"
export default component.exports